import { z } from 'zod';

export const appSchemes = z.enum([
  'affine',
  'affine-canary',
  'affine-beta',
  'affine-internal',
  'affine-dev',
]);

const appChannelSchemes = z.enum(['stable', 'canary', 'beta', 'internal']);

export type Scheme = z.infer<typeof appSchemes>;
export type Channel = z.infer<typeof appChannelSchemes>;

export const schemeToChannel = {
  affine: 'stable',
  'affine-canary': 'canary',
  'affine-beta': 'beta',
  'affine-internal': 'internal',
  'affine-dev': 'canary', // dev does not have a dedicated app. use canary as the placeholder.
} as Record<Scheme, Channel>;

export const channelToScheme = {
  stable: 'affine',
  canary:
    process.env.NODE_ENV === 'development' ? 'affine-dev' : 'affine-canary',
  beta: 'affine-beta',
  internal: 'affine-internal',
} as Record<Channel, Scheme>;

export const appIconMap = {
  stable: '/imgs/curiescious-logo.svg',
  canary: '/imgs/curiescious-logo.svg',
  beta: '/imgs/curiescious-logo.svg',
  internal: '/imgs/curiescious-logo.svg',
} satisfies Record<Channel, string>;

export const appNames = {
  stable: 'Curiescious',
  canary: 'Curiescious Canary',
  beta: 'Curiescious Beta',
  internal: 'Curiescious Internal',
} satisfies Record<Channel, string>;

export const appSchemaUrl = z.custom<string>(
  (url: string) => {
    try {
      return appSchemes.safeParse(new URL(url).protocol.replace(':', ''))
        .success;
    } catch {
      return false;
    }
  },
  { message: 'Invalid URL or protocol' }
);
